var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.paymentMethods && _vm.paymentMethods.paypal)?_c('div',{staticClass:"pt-2"},[_c('p',[_vm._v("\n        "+_vm._s(_vm.$t('_checkout._payment.paypalInstruction'))+"\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }